import {PostDto} from '../postDto';

export class AddPostRequest {
  postDto: PostDto;
}
